import type { ActionFunction } from '@remix-run/node';
import { json } from '@remix-run/node';
import invariant from 'tiny-invariant';
import type {
    DeleteDesignBoardItemByPageMutation,
    DeleteDesignBoardItemByPageMutationVariables,
} from 'generated/graphql';
import { DeleteDesignBoardItemByPageDocument } from 'generated/graphql';

export const REMOVE_DESIGN_BOARD_ITEMS_BY_PAGE_API_ROUTE =
    '/actions/remove-items-from-design-board-by-page';

const DEFAULT_FAILED_MESSAGE = 'Failed to remove items from design board.';

/**
 * This mutation is similar to REMOVE_BUILD_HUB_INSPIRATION_ITEMS_API_ROUTE
 * but is deleting by library item id instead of the pin's ID.
 * This is needed for use with the pin saving/removing modal as the useHandleFollow works with library item ID not the pin's ID
 */
export const action: ActionFunction = async ({ request, context }) => {
    const data = await request.formData();

    invariant(data.get('boardId'), 'Board id required.');
    invariant(data.get('pageIds[]'), 'Page ids required for remove.');

    const variables: DeleteDesignBoardItemByPageMutationVariables = {
        BoardID: Number(data.get('boardId')),
        LibraryItemIDs: data.getAll('pageIds[]').map(Number),
    };

    try {
        const { data: result } = await context.client.mutate<
            DeleteDesignBoardItemByPageMutation,
            DeleteDesignBoardItemByPageMutationVariables
        >({
            mutation: DeleteDesignBoardItemByPageDocument,
            variables,
        });

        const validResult = result?.deletePinsByPage;
        if (!validResult) {
            return json({
                buildHubUpsert: {
                    __typename: 'ServerError',
                    Message: DEFAULT_FAILED_MESSAGE,
                },
            });
        }

        return json(result);
    } catch (error) {
        return json({
            buildHubUpsert: {
                __typename: 'ServerError',
                Message:
                    error instanceof Error
                        ? error.message
                        : DEFAULT_FAILED_MESSAGE,
            },
        });
    }
};
